
import { useContext } from '@nuxtjs/composition-api'

export default {
  setup() {
    const {
      app: { router },
    } = useContext()

    let pageRoute = '' as string | null | undefined

    if (typeof router === 'object') {
      pageRoute = router.app.$route.name
    }

    return {
      pageRoute,
    }
  },
}
